export const environment = {
    version: require('../../package.json').version,
    production: false,
    //firebaseFunctionsUrl: "http://192.168.216.149:5001/composer-tools/europe-west1/api",
    //firebaseFunctionsUrl: "http://192.168.1.100:5001/composer-tools/europe-west1/api",
    firebaseFunctionsUrl: "http://127.0.0.1:5001/totamusica-dev/us-central1/",
    useEmulators: true
}